import { render, staticRenderFns } from "./ManageAcademyPackage.vue?vue&type=template&id=752e490e&scoped=true"
import script from "./ManageAcademyPackage.vue?vue&type=script&lang=js"
export * from "./ManageAcademyPackage.vue?vue&type=script&lang=js"
import style0 from "./ManageAcademyPackage.vue?vue&type=style&index=0&id=752e490e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e490e",
  null
  
)

export default component.exports